/**
 * Created by Ning Jiang on 2/22/2018.
 */

import {FreespinOutroController} from "@nolimitcity/slot-game/bin/game/screen/freespinoutro/FreespinOutroController";
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";

export class WildNudgeFreespinOutroController extends FreespinOutroController {

    public static readonly CLOSE_COMPLETED:string = "Close_Completed";

    constructor(config:IScreenConfig) {
        super(config);
    }

    protected onCloseComplete():void {
        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : this._serverData!.nextMode}));
        EventHandler.dispatchEvent(new GameEvent(WildNudgeFreespinOutroController.CLOSE_COMPLETED));

        super.onCloseComplete();
    }
}